import React from 'react';

import { responsiveDeeplinkUrl } from '../deeplinkUtils';
import ExternalLink from './ExternalLink';
import Svg from './Svg';
import '../styles/footer.scss';

const Footer = () => (
  <div className="footer">
    <div className="footer-powered">
      <p>{__('Powered by')}</p>
      <ExternalLink ariaLabel="Fishbrain" href={responsiveDeeplinkUrl('footer')}>
        <Svg viewBox="0 0 138 26" className="footer-logo" icon="logo" />
      </ExternalLink>
    </div>
  </div>
);

export default Footer;
